"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourControlActions = void 0;
var _ = require("lodash");
var moment = require("moment");
var server_1 = require("../../../../helpers/server");
var constants_1 = require("../../../../constants");
var react_toastify_1 = require("react-toastify");
var HourControlActions = /** @class */ (function () {
    function HourControlActions() {
    }
    // YYYY-MM-DD Gets monday of the week, date
    HourControlActions.setSelectedWeek = function (monday) {
        return {
            type: HourControlActions.SELECT_WEEK,
            payload: monday,
        };
    };
    HourControlActions.getWorkLogsOverview = function (weekNumber) {
        var _this = this;
        var start_date = moment().isoWeek(weekNumber).startOf('isoWeek').format('YYYY-MM-DD');
        var end_date = moment().isoWeek(weekNumber).endOf('isoWeek').format('YYYY-MM-DD');
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var results, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.WEEK_HOURS).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.WEEK_HOURS_URI, { start_date: start_date, end_date: end_date })];
                    case 2:
                        results = (_a.sent()).results;
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.WEEK_HOURS).success, payload: { results: results } });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.WEEK_HOURS).fail, payload: error_1 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    HourControlActions.getUserLog = function (userId, day) {
        var _this = this;
        var start_date = moment(day).startOf('day').toDate();
        var end_date = moment(day).endOf('day').toDate();
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var results, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.GET_USER_LOG).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.WORKLOG_LIST_URI, { start_date: start_date, end_date: end_date, userId: userId })];
                    case 2:
                        results = (_a.sent()).results;
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.GET_USER_LOG).success, payload: { results: results, userId: userId, day: day } });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.GET_USER_LOG).fail, payload: error_2 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    HourControlActions.getWorkLogList = function (weekNumber, userIds) {
        var _this = this;
        var start_date = moment().isoWeek(weekNumber).startOf('isoWeek').format('YYYY-MM-DD');
        var end_date = moment().isoWeek(weekNumber).endOf('isoWeek').format('YYYY-MM-DD');
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var results, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.WORKLIG_LIST).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.get)(constants_1.API.WORKLOG_LIST_URI, { start_date: start_date, end_date: end_date, userIds: userIds })];
                    case 2:
                        results = (_a.sent()).results;
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.WORKLIG_LIST).success, payload: { results: results } });
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.WORKLIG_LIST).fail, payload: error_3 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    HourControlActions.saveUserWorklogs = function (ownerId, date_worked, worklogs) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var updatedWorklogs_1, error_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.SAVE_LOG_IN_SERVER).request });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.SAVE_WORKLOGS, {
                                owner_id: ownerId,
                                date: date_worked,
                                worklogs: worklogs,
                            })];
                    case 2:
                        updatedWorklogs_1 = _b.sent();
                        // returns the same worklogs but gpsHours recalculated
                        if (updatedWorklogs_1.result) {
                            worklogs.filter(function (worklog) {
                                return worklog.approvedHours + worklog.hours !== 0;
                            }).forEach(function (worklog) {
                                var updatedWorkLog = updatedWorklogs_1.entity.find(function (entity) {
                                    return entity._id.toString() === worklog._id;
                                });
                                if (updatedWorkLog) {
                                    worklog.gpsHours = updatedWorkLog.gpsHours;
                                }
                            });
                        }
                        dispatch({
                            type: (0, server_1.apiActions)(HourControlActions.SAVE_LOG_IN_SERVER).success,
                            payload: { results: (_a = {}, _a[ownerId] = { worklogs: worklogs }, _a), day: date_worked, userId: ownerId },
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _b.sent();
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.SAVE_LOG_IN_SERVER).fail, payload: error_4 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    HourControlActions.addUseWorkLog = function (ownerId, date_worked, worklogs) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                // We update the User in local with the locals
                dispatch({
                    type: HourControlActions.ADD_WORKLOG,
                    payload: { results: (_a = {}, _a[ownerId] = { worklogs: worklogs }, _a), day: date_worked, userId: ownerId },
                });
                return [2 /*return*/];
            });
        }); };
    };
    HourControlActions.approveUserHours = function (selectedUsers, approverId, dateStart) {
        var _this = this;
        return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var results, success, message, _i, results_1, approvedWeek, index, userFullname, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch({ type: (0, server_1.apiActions)(HourControlActions.APPROVE_USER_HOURS).request });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, server_1.post)(constants_1.API.APPROVE_HOURS, {
                                users: _.map(selectedUsers, '_id'),
                                approver_id: approverId,
                                date_from: dateStart,
                            })];
                    case 2:
                        results = _a.sent();
                        success = _.countBy(results, 'success');
                        if (success.hasOwnProperty('true')) {
                            message = success.true === 1 ? 'gebruiker is ' : success.true + ' gebruikers zijn ';
                            react_toastify_1.toast.success(message + 'goedgekeurd');
                        }
                        for (_i = 0, results_1 = results; _i < results_1.length; _i++) {
                            approvedWeek = results_1[_i];
                            index = selectedUsers.map(function (user) { return user._id; }).indexOf(approvedWeek.owner);
                            userFullname = selectedUsers[index].firstName + ' ' + selectedUsers[index].lastName;
                            if (!approvedWeek.success) {
                                react_toastify_1.toast.error('Voor ' + userFullname + ' ' + approvedWeek.message);
                            }
                        }
                        dispatch({
                            type: (0, server_1.apiActions)(HourControlActions.APPROVE_USER_HOURS).success,
                            payload: results,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _a.sent();
                        dispatch({
                            type: (0, server_1.apiActions)(HourControlActions.APPROVE_USER_HOURS).fail,
                            error: error_5.message,
                        });
                        react_toastify_1.toast.error('Server fault: ' + error_5.message);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    HourControlActions.WEEK_HOURS = 'WEEK_HOURS';
    HourControlActions.WORKLIG_LIST = 'GET_WORKLOGS_LIST_BY_USER';
    HourControlActions.SELECT_WEEK = 'SELECT_WEEK';
    HourControlActions.GET_USER_LOG = 'GET_USER_LOG';
    HourControlActions.SAVE_LOG_IN_SERVER = 'SAVE_LOG_IN_SERVER';
    HourControlActions.ADD_WORKLOG = 'ADD_WORKLOG';
    // GPS can be refactor to another reducer
    HourControlActions.GET_USER_GPS_NODES = 'USER_GPS_NODES';
    HourControlActions.GET_USER_STEPS = 'USER_STEPS';
    HourControlActions.APPROVE_USER_HOURS = 'APPROVE_USER_HOURS';
    return HourControlActions;
}());
exports.HourControlActions = HourControlActions;
